import {NoticeMetricsSummary} from "../../stores/domainStore/pages/models/noticeMetricsSummary";
import {formatThousands} from "../stringUtils";
import {MetricsColumn, MetricsRow} from "./metricTypes";

export class NoticeMetricsRow extends MetricsRow {
  totalNotices: number = 0;
  singleVillage: number = 0;
  multiVillage: number = 0;

  readCount: number = 0;
}

export type NoticeMetricsColumn = MetricsColumn<
  NoticeMetricsSummary,
  NoticeMetricsRow
>;

/**
 * How we calculate + display each metric for the notice table
 */
export const NoticeMetricsTypes: NoticeMetricsColumn[] = [
  {
    dataField: "village",
    headerLabel: "Village",
    sort: true,
    formatter: (data: NoticeMetricsRow) =>
      !data.isTotalsRow && data.village
        ? data.village.name
        : "All Selected Villages",
    rawValue: (data: NoticeMetricsRow) => data.village?.name ?? ""
  },
  {
    dataField: "totalNotices",
    headerLabel: "Total Count",
    sort: true,
    valueInit: (data: NoticeMetricsSummary[], dest: NoticeMetricsRow) => {
      dest.totalNotices = data.length;
    },
    formatter: (data: NoticeMetricsRow) => formatThousands(data.totalNotices),
    rawValue: (data: NoticeMetricsRow) => data.totalNotices
  },
  {
    dataField: "singleVillage",
    headerLabel: "Single Village",
    sort: true,
    valueInit: (data: NoticeMetricsSummary[], dest: NoticeMetricsRow) => {
      dest.singleVillage = data.filter((n) => !n.isMultiVillage).length;
    },
    formatter: (data: NoticeMetricsRow) => formatThousands(data.singleVillage),
    rawValue: (data: NoticeMetricsRow) => data.singleVillage
  },
  {
    dataField: "multiVillage",
    headerLabel: "Multi Village",
    sort: true,
    valueInit: (data: NoticeMetricsSummary[], dest: NoticeMetricsRow) => {
      dest.multiVillage = data.filter((n) => n.isMultiVillage).length;
    },
    formatter: (data: NoticeMetricsRow) => formatThousands(data.multiVillage),
    rawValue: (data: NoticeMetricsRow) => data.multiVillage
  },
  {
    dataField: "readCounts",
    headerLabel: "Average Read Count",
    tooltip:
      "Excludes multi-village updates, read count divided by number of notices.",
    sort: true,
    valueInit: (data: NoticeMetricsSummary[], dest: NoticeMetricsRow) => {
      let singleVillageCount = 0;
      let totalViews = 0;
      data
        .filter((n) => !n.isMultiVillage)
        .forEach((n) => {
          totalViews += n.readCount ?? 0;
          singleVillageCount += 1;
        });

      dest.readCount =
        singleVillageCount === 0
          ? 0
          : Math.round(totalViews / singleVillageCount);
    },
    formatter: (data: NoticeMetricsRow) => formatThousands(data.readCount),
    rawValue: (data: NoticeMetricsRow) => data.readCount
  }
];
